import React from 'react';

import './Footer.css';

import logoGovBRBranco from '../../assets/logo/logoGovBrBranco.svg';
import logoEbserhMEC from '../../assets/logo/logoHuBrasil.svg';

function Footer() {
  return (
    <footer className="footer">
      <div className="contentFooter">
        <img alt="logo govbr" src={logoGovBRBranco} />
        <img
          alt="logo ebserh MEC"
          src={logoEbserhMEC}
          style={{ width: '246px', height: 'auto' }}
        />
      </div>
    </footer>
  );
}

export default Footer;
